import { createSlice } from "@reduxjs/toolkit";
import { getAuthData } from "./authSlice";

const convertPriceAPI = async (item, type) => {
  const authData = getAuthData();

  if (!authData.companyCode || !authData.groupCode || !authData.token) {
    throw new Error("signin");
  }

  const body = JSON.stringify({
    login: [
      ["token", "=", authData?.token],
      ["group_code", "=", authData?.groupCode],
      ["company_code", "=", authData?.companyCode],
    ],
    params: [
      ["cur1", "=", item?.cur],
      ["cur2", "=", sessionStorage.getItem("curId")],
      [
        "amount",
        "=",
        type === "price"
          ? item?.price?.replaceAll(",", "")
          : item?.original_price?.replaceAll(",", ""),
      ],
    ],
  });

  try {
    const response = await fetch(
      process.env.REACT_APP_API_URL + "clientPortal/ExchangeRate",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      },
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data?.price || item.price; // Default to the original price if conversion fails
  } catch (error) {
    throw error;
  }
};

const initialState = {
  products: [],
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCartSuccess: (state, action) => {
      const updatedItem = action.payload;

      const item = state.products.find((product) => {
        return (
          product._id === updatedItem._id &&
          (Number(product?.color?.g_color) || null) ===
            (Number(updatedItem?.color?.g_color) || null) &&
          (Number(product?.size?.g_size) || null) ===
            (Number(updatedItem?.size?.g_size) || null) &&
          (Number(product?.lot?.lotno) || null) ===
            (Number(updatedItem?.lot?.lotno) || null) &&
          (Number(product?.cupsize?.g_cupsize) || null) ===
            (Number(updatedItem?.cupsize?.g_cupsize) || null)
        );
      });

      if (item) {
        // Update the existing item
        item.quantity += updatedItem.quantity;
        item.price = updatedItem.price; // Update price if necessary
      } else {
        // Add the new item
        state.products.push(updatedItem);
      }
    },
    increaseQuantity: (state, action) => {
      const { _id, color, size, lot, cupsize } = action.payload;

      const item = state.products.find((product) => {
        return (
          product._id === _id &&
          (product?.color?.g_color || null) === (color?.g_color || null) &&
          (product?.size?.g_size || null) === (size?.g_size || null) &&
          (product?.lot?.lotno || null) === (lot?.lotno || null) &&
          (product?.cupsize?.g_cupsize || null) === (cupsize?.g_cupsize || null)
        );
      });

      if (item) {
        item.quantity++;
      }
    },
    decreaseQuantity: (state, action) => {
      const { _id, color, size, lot, cupsize } = action.payload;

      const item = state.products.find((product) => {
        return (
          product._id === _id &&
          (product?.color?.g_color || null) === (color?.g_color || null) &&
          (product?.size?.g_size || null) === (size?.g_size || null) &&
          (product?.lot?.lotno || null) === (lot?.lotno || null) &&
          (product?.cupsize?.g_cupsize || null) === (cupsize?.g_cupsize || null)
        );
      });

      if (item && item.quantity > 1) {
        item.quantity--;
      }
    },
    setQuantity: (state, action) => {
      const { _id, color, size, lot, quantity, cupsize } = action.payload;

      const item = state.products.find((product) => {
        return (
          product._id === _id &&
          (product?.color?.g_color || null) === (color?.g_color || null) &&
          (product?.size?.g_size || null) === (size?.g_size || null) &&
          (product?.lot?.lotno || null) === (lot?.lotno || null) &&
          (product?.cupsize?.g_cupsize || null) === (cupsize?.g_cupsize || null)
        );
      });

      if (item) {
        item.quantity = Math.max(0, quantity);
      }
    },
    deleteItem: (state, action) => {
      const { _id, color, size, lot, cupsize } = action.payload;

      state.products = state.products.filter((product) => {
        return !(
          product._id === _id &&
          (product?.color?.g_color || null) === (color?.g_color || null) &&
          (product?.size?.g_size || null) === (size?.g_size || null) &&
          (product?.lot?.lotno || null) === (lot?.lotno || null) &&
          (product?.cupsize?.g_cupsize || null) === (cupsize?.g_cupsize || null)
        );
      });
    },
    resetCart: (state) => {
      state.products = [];
    },
  },
});

export const {
  addToCartSuccess,
  increaseQuantity,
  decreaseQuantity,
  setQuantity,
  deleteItem,
  resetCart,
} = cartSlice.actions;

export const addToCart = (item) => async (dispatch) => {
  try {
    let convertedPrice;
    let convertedOriginalPrice;
    if (item.cur === Number(sessionStorage.getItem("curId"))) {
      convertedPrice = item.price;
      convertedOriginalPrice = item?.original_price;
    } else {
      convertedPrice = await convertPriceAPI(item, "price");
      convertedOriginalPrice = await convertPriceAPI(item, "original");
    }

    const updatedItem = {
      ...item,
      price: convertedPrice,
      original_price: convertedOriginalPrice,
    };
    dispatch(addToCartSuccess(updatedItem));
  } catch (error) {
    console.log(error);
    throw new Error("Could not convert");
  }
};

export default cartSlice.reducer;
